import { HAS_WINDOW } from '@eventbrite/feature-detection';

interface Transcend {
  showConsentManager?: (options?: { viewState: string }) => void;
}

type TranscendWindow = Window & {
  transcend?: Transcend;
};

export const useConsentManager = () => {
  const showConsentManager = (viewState: string) => {
    if (HAS_WINDOW) {
      (window as TranscendWindow)?.transcend?.showConsentManager?.({
        viewState,
      });
    }
  };

  return { showConsentManager };
};

export const useFooterHandlers = () => {
  const { showConsentManager } = useConsentManager();

  const handleCookiePreferences = (e: React.MouseEvent) => {
    e.preventDefault();
    showConsentManager('CompleteOptions');
  };

  const handleDoNotSell = (e: React.MouseEvent) => {
    e.preventDefault();
    showConsentManager('DoNotSellExplainer');
  };

  return {
    handleCookiePreferences,
    handleDoNotSell,
  };
};
